<template >
  <el-row >
    <el-card class="box-card" >
      <div slot="header" >
        <el-row
            class="actions_btns"
            type="flex"
            justify="center"
            v-if="!embedMode" >
          <s-responsive-panel
              :go-responsive="isMobileDevice()"
              toast-icon="fas fa-cog" >
            <el-col class="square_btn_left" >
              <s-btn-delete @go="deletBusiness()" ></s-btn-delete >
              <el-button
                  v-if="businessData.archive"
                  style="float:right;"
                  type="primary"
                  plain
                  title="Ενεργοποιησε επαφη"
                  @click="archiveContact(false)" >
                <i class="material-icons" >account_box</i >
              </el-button >
              <el-button
                  v-else
                  title="Απενεργοποιησε επαφη"
                  style="float:left;"
                  type="warning"
                  plain
                  @click="archiveContact(true)" >
                <i class="material-icons" >perm_identity</i >
              </el-button >
              <el-button
                  style="float:right;"
                  type="success"
                  palin
                  @click="saveBusiness()" >
                <i class="material-icons" >save</i >
              </el-button >

            </el-col >
          </s-responsive-panel >
        </el-row >
        <el-row v-else >
          <el-col
              :md="18"
              :sm="24" >
            <el-row
                class="queryBusiness"
                :gutter="4" >
              <el-col
                  :sm="18"
                  :xs="18" >
                <el-autocomplete
                    ref="searchBusiness"
                    :disabled="disabled"
                    style="width:100%"
                    v-model="seachBusiness"
                    :fetch-suggestions="queryBusiness"
                    placeholder="Διαλέξτε κάποιον πελάτη ή δημιουργήστε εναν καινουριο"
                    @select="handleSelect"
                    @blur="validateBusiness" >
                  <template slot-scope="{ item }" >
                    <div
                        class="option"
                        v-if="item.alias&&item.alias!=''" >
                      <div class="mainTitle" >{{ item.alias }}</div >
                      <div class="quoted" >{{ item['name-afm'] }}</div >
                      <div class="quoted" >{{ item['profession'] }}</div >
                    </div >
                    <div
                        class="option"
                        v-else >
                      <div class="mainTitle" >{{ item['name-afm'] }}</div >
                      <div class="quoted" >{{ item['profession'] }}</div >
                    </div >
                  </template >
                </el-autocomplete >
              </el-col >
              <el-col
                  :sm="6"
                  :xs="6" >
                <el-button
                    :disabled="disabled"
                    v-if="!hasValues(businessData,'businessId')"
                    type="success"
                    @click="validateNewBusiness" >Νεος Πελατης
                </el-button >
                <template v-else >
                  <el-button
                      :disabled="disabled"
                      type="primary"
                      @click="editBusiness=!editBusiness"
                      class="fa-edit_btn"
                      icon="el-icon-edit" >

                  </el-button >
                  <el-link
                      type="warning"
                      :href="'/spa/#/transactions/in/contact/'+businessData.businessId" >
                    <i class="material-icons" >call_missed_outgoing</i >
                  </el-link >
                </template >
              </el-col >
            </el-row >
          </el-col >
          <!--          <el-col :md="6" :sm="24" v-if="hasValues(businessData,'balance')">-->
          <!--            <h4>-->
          <!--              <small>Υπολοιπο:</small>-->
          <!--              {{$theMoney(businessData.balance,'.')}}&euro;-->
          <!--            </h4>-->
          <!--          </el-col>-->
        </el-row >
      </div >

      <div >
        <transition name="el-zoom-in-bottom" >
          <el-row
              v-show="showDetails&&!disabled"
              class="dark"
              style="padding-bottom:10px;padding-top:10px" >
            <el-col :md="24" >
              <el-row
                  :gutter="30"
                  style="padding-bottom:10px;" >
                <el-col :md="9" >
                  <label >Ψευδώνυμο</label >
                  <el-input
                      v-model="businessData.alias"
                      @blur="validateBusiness"
                      @input="updateBusiness"
                      placeholder="...κάτι να μην τον μπερδεύης"
                      ref="cname" ></el-input >
                </el-col >
                <el-col :md="9" >
                  <label >Όνομα</label >
                  <el-input
                      v-model="businessData.name"
                      @blur="validateBusiness"
                      @input="updateBusiness"
                      ref="cname" ></el-input >
                </el-col >
                <el-col :md="6" >
                  <label >ΑΦΜ</label >
                  <el-input
                      v-model="businessData.afm"
                      @blur="validateBusiness"
                      @input="updateBusiness"
                      ref="afm" ></el-input >
                </el-col >
              </el-row >
              <el-row
                  :gutter="30"
                  style="padding-bottom:10px;" >
                <el-col :md="12" >
                  <label >Επάγγελμα</label >
                  <el-input
                      v-model="businessData.profession"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
                <el-col :md="12" >
                  <label >ΔΟΥ</label >
                  <el-input
                      v-model="businessData.doy"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
              </el-row >
              <el-row
                  :gutter="30"
                  style="padding-bottom:10px;" >
                <el-col :md="8" >
                  <label >Διεύθυνση</label >
                  <el-input
                      v-model="businessData.adress"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
                <el-col :md="8" >
                  <label >Πόλη</label >
                  <el-input
                      v-model="businessData.city"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
                <el-col :md="8" >
                  <label >Τ.Κ.</label >
                  <el-input
                      v-model="businessData.postcode"

                      @input="updateBusiness" ></el-input >
                </el-col >
              </el-row >
              <el-row
                  :gutter="30"
                  style="padding-bottom:10px;" >
                <el-col :md="8" >
                  <label >Τηλεφωνο</label >
                  <el-input
                      v-model="businessData.phone"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
                <el-col :md="8" >
                  <label >Email</label >
                  <el-input
                      v-model="businessData.email"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
                <el-col :md="8" >
                  <label >Τραπεζα</label >
                  <el-input
                      v-model="businessData.bankdetails"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
              </el-row >
              <el-row
                  :gutter="30"
                  style="padding-bottom:10px;" >
                <el-col :md="24" >
                  <label >Σχολια</label >
                  <el-input
                      v-model="businessData.comments"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
                <el-col :md="24" >
                  <label >Extras</label >
                  <el-input
                      v-model="businessData.externalLinkId"
                      @blur="validateBusiness"
                      @input="updateBusiness" ></el-input >
                </el-col >
              </el-row >
            </el-col >
          </el-row >
        </transition >
      </div >
    </el-card >
    <!-- <el-dialog title="Tips" :visible.sync="resolveBusiness" width="30%" :append-to-body="true">
      <span>This is a message</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resolveBusiness = false">Cancel</el-button>
        <el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
      </span>
    </el-dialog>-->
  </el-row >
</template >

<script >
import * as api from "~/api/resource";
import _ from "lodash";

export default {
  name: "BuisnessPanel",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    searchString: {
      type: String,
      default: null
    },
    confirmUpdate: {
      type: Boolean,
      default: false
    },
    contactData: {
      type: Object,
      default: () => {
      }
    },
    bridgeMode: {
      type: Boolean,
      default: false
    },
    embedMode: {type: Boolean, default: false},
    businessId: {
      default: null
    }
  },
  data() {
    return {
      // ctx: 1,
      allowEdit: false,
      editBusiness: false,
      resolveBusiness: false,
      seachBusiness: null,
      // selectedBusiness: {},
      businessData: {},
      userProfile: UserProfile,
      loaded: false
    };
  },
  watch: {
    "contactData.businessId"(val, oldval) {
      if (val && val != "") {
        this.businessData = this.contactData;
        this.editBusiness = true;
        // this.allowEdit = false;
      }
    },
    businessId: {
      async handler(newVal, oldval) {
        if (!newVal) {
          this.businessData = {};
          this.seachBusiness = null;

          return;
        }
        _log_("oooo....", newVal, oldval);
        if (newVal && oldval != newVal) {
          var {data} = await api.fetchProcessor("business/get", {
            objectId: newVal
          });
          this.businessData = data.object;
          this.seachBusiness = this.businessData.name;
          // this.selectedBusiness = JSON.parse(JSON.stringify(data.object));
        }
        else this.businessData = {};
        this.allowEdit = false;
        this.$emit("businessChange", data.object);
      },
      immediate: true
    }
  },
  computed: {
    compactMode() {
      return this.businessId != null && this.businessId != "";
    },
    showDetails() {
      // return true
      if (!this.embedMode) return true;
      return this.editBusiness;
      return false;
    }
  },
  methods: {
    async deletBusiness() {
      try {
        const {data} = await api.removeObject("business", this.businessData);
        _log_("error", data);
        if (data.success) {
          this.$emit("delete", this.businessData);
          this.businessData = {};
        }
        else this.$message.error("Δεν..., " + data.message);
        // _log_("error", w);
      }
      catch (error) {
        _log_("error", error);
        // this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("done", null);
    },
    async archiveContact(state) {
      this.businessData.archive = state ? 1 : 0;
      // @click="wBusiness.archive=1&&wBusiness.businessId;pipeActions(['wBusiness=>business/update>=wBusiness'])"
      var {data} = await api.fetchProcessor(
          "business/update",
          this.businessData
      );
    },
    focus() {
      _log_("goldv");
      this.$nextTick(() => {
        this.$refs["searchBusiness"].focus();
      });
    },
    validateNewBusiness() {
      const vm = this;
      if (this.confirmUpdate)
        this.$confirm("Αυτο το παραστατατικό έχει εκδωθεί", "ΠΡΟΣΟΧΗ!!!", {
          confirmButtonText: "Σε παρακαλώ αλλαξε τον πελάτη και μην σε νοιάζει",
          cancelButtonText: "Άστο καλήτερα",
          type: "warning",
          center: true
        })
            .then(() => {
              vm.createBusiness();
            })
            .catch(() => {
              vm.seachBusiness = vm.searchString;
            });
      else vm.createBusiness();
    },
    async createBusiness() {
      this.businessData = {};
      this.editBusiness = true;
      if (!this.seachBusiness) {
        this.$nextTick(() => {
          this.$refs["cname"].focus();
        });
        return;
      }
      this.businessData.isbusiness = this.isbusiness;
      const searchIsName = isNaN(this.seachBusiness);
      if (searchIsName) this.businessData.name = this.seachBusiness;
      else this.businessData.afm = this.seachBusiness;
      var {data} = await api.fetchProcessor(
          "business/update",
          this.businessData
      );
      this.businessData = data.object;

      this.$nextTick(() => {
        if (searchIsName) this.$refs["afm"].focus();
        else this.$refs["cname"].focus();
      });
      this.$emit("businessChange", this.businessData);
    },
    async saveBusiness() {
      const vm = this;
      var go = true;
      if (this.businessData.businessId && !this.allowEdit) {
        var {data} = await api.fetchProcessor("timologio/getlist", {
          businessId: this.businessData.businessId,
          issue_state: "issued"
        });
        if (data && data.results && data.results.length) {
          go = false;
          this.$confirm(
              "Αυτος ο πελάτης έχει εκδωμένα παραστατικά. ΑΝ αλλάξετε τα στοιχεία του, θα αλλάξoυν και στα προηγουμενα παραστατικά",
              {
                confirmButtonText:
                    "Σε παρακαλώ αλλαξε τα στοιχεία και μην σε νοιάζει",
                cancelButtonText: "Άστο καλήτερα",
                type: "warning",
                center: true
              }
          )
              .then(async () => {
                vm.allowEdit = true;
                var {data} = await api.fetchProcessor(
                    "business/update",
                    vm.businessData
                );
                vm.businessData.businessId = data.object.businessId;
                vm.$emit("businessChange", vm.businessData);
              })
              .catch(() => {
                // vm.seachBusiness = vm.searchString;
              });
        }
        // _log_("ccrrr...", data);
      }
      if (go) {
        vm.allowEdit = true;
        var {data} = await api.fetchProcessor(
            "business/update",
            this.businessData
        );
        this.businessData.businessId = data.object.businessId;
        this.$emit("businessChange", this.businessData);
      }
    },
    async updateBusiness() {
      if (this.embedMode) await this.saveBusiness();
      this.$emit("detailsChanged", this.businessData);
    },
    handleSelect(e) {
      _log_("aXa C,", e);
      const vm = this;
      this.businessData = e;

      if (this.confirmUpdate)
        this.$confirm("Αυτο το παραστατατικό έχει εκδωθεί", "ΠΡΟΣΟΧΗ!!!", {
          confirmButtonText: "Σε παρακαλώ αλλαξε τον πελάτη και μην σε νοιάζει",
          cancelButtonText: "Άστο καλήτερα",
          type: "warning",
          center: true
        })
            .then(() => {
              vm.$emit("businessChange", e);
            })
            .catch(() => {
              vm.seachBusiness = vm.searchString;
            });
      else this.$emit("businessChange", e);
      // this.selectedBusiness = JSON.parse(JSON.stringify(e));
    },
    validateBusiness(e) {
      // const current = this.businessData,
      //   working = this.selectedBusiness;
      // var dataChanged = false;
      // if (!working.businessId) dataChanged = true;
      // else
      //   for (const key in current) {
      //     if (current.hasOwnProperty(key)) {
      //       if (current[key] != working[key]) {
      //         dataChanged = true;
      //         break;
      //       }
      //     }
      //   }
      // this.resolveBusiness = dataChanged;
      // _log_("aXa NNC,", this.businessData);
    },
    async queryBusiness(queryString, cb) {
      var {data} = await api.fetchProcessor("business/getfieldoptions", {
        isbusiness: this.isbusiness,
        archive: 0,
        all: 1,
        labelField: "name-afm",
        filter: queryString
      });

      cb(_.values(data.results));
    }
  },

  async mounted() {
    if (this.bridgeMode !== false) {
      if (this.contactData.id) {
        let data = await api.getObject("business/get", {
          bridgeField: 'relid',
          relid: this.contactData.id,
          isbusiness:1
        });
        if (data) {
          this.businessData = data;
          this.$emit("businessChange", this.businessData);
        }
      }
      return
    }
    // this.ctx = this.$route.name.indexOf("out") == 0 ? 0 : 1;
    if (this.contactData) this.businessData = this.contactData;
    else if (this.businessId) {
      this.seachBusiness = this.searchString;
      let {data} = await api.fetchProcessor("business/get", {
        businessId: this.businessId
      });
      if (data) {
        this.businessData = data.object;
        this.$emit("businessChange", this.businessData);
      }
      else alert("problem loading business");
    }
    _log_("read..CC>>..", this.embedMode);
    if (!this.embedMode) this.editBusiness = !this.businessData.businessId;
    this.loaded = true;
  }
};
</script >

<style >
div.option div.mainTitle {
  font-weight: bold;
}
</style >
